import React, { useState, useEffect } from 'react';
import { get, post } from '../Services/http';

const MyPageEnjoyClubCollapse = ({
  bonusNotMember,
  bonusAvailableLabel,
  bonusAvailable,
  bonusTitle,
  bonusDescription,
  bonusImageUrl,
  bonusSignOut,
  bonusSignUp,
}) => {
  const [isMember, setIsMember] = useState(false);

  const [currentAvailableBonus, setCurrentAvailableBonus] = useState(bonusAvailable);

  useEffect(() => {
    checkMemberShipStatus();
  }, []);

  async function checkMemberShipStatus() {
    try {
      const response = await get('/api/enjoyClub/check');
      const data = await response.json();
      setIsMember(data.isMember);
      setCurrentAvailableBonus(data.availableBonus);
    } catch (err) {
      console.error('Error fetching Enjoy Club membership', err.message);
    }
  }

  async function onMembershipChange() {
    try {
      if (isMember) {
        await post('/api/enjoyClub/signOut');
      } else {
        await post('/api/enjoyClub/signUp');
      }
      checkMemberShipStatus();
    } catch (err) {
      console.error('Error updating Enjoy Club membership', err.message);
    }
  }

  return (
    <div className="current-bonus-wrapper">
      <div className='grid gap-8 lg:gap-16 lg:grid-cols-[auto_1fr]'>
        <img className="bonus-logo size-[160px] lg:size-[308px] object-contain aspect-square m-auto" src={bonusImageUrl} alt={bonusTitle} />
        <div className='space-y-6'>
          <div className='space-y-[10px]'>
            <div className='text-sm text-text-secondary font-bold'>{isMember ? `${bonusAvailableLabel}: ${currentAvailableBonus}`: bonusNotMember}</div>
            <h3 className='text-xl text-text-secondary font-bold'>{bonusTitle}</h3>
            {bonusDescription && (
              <div
                className="text-sm text-text-secondary"
                dangerouslySetInnerHTML={{
                  __html: bonusDescription,
                }}
              ></div>
            )}
          </div>
          <div className="bonus-membership-update">
            <button className="button text-sm min-w-[200px] w-full md:w-auto" type="button" onClick={onMembershipChange}>
              {isMember ? bonusSignOut : bonusSignUp}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPageEnjoyClubCollapse;
